import React from 'react';
//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import styles from 'src/asset/scss/styles/userPartnerCalcDetail.module.scss';
//compWrapper
import SubtitleArea from 'src/webapp/views/wrapper/SubtitleArea';//서브타이틀공통컴포넌트
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트

export default function Search(props) {
    const { searchRef, cnt } = props;//props

    /* ==================== 검색이벤트 ==================== */
    const handleKeydown = (e) => {
        if(e.key === 'Enter') {
            props.onSearch(0, 2);
        }
    };
    const onChangeHandler = (e) => {
        const value = e.target.value;
        if(value.length > 0) { return; }
        props.onSearch(0, 2);
    }
    /* ==================== 검색이벤트 ==================== */

    return (
        <SubtitleArea title={'이용 내역'} cnt={`${cnt}건`}>
            <Element tag={`div`} className={styles.itemSearchwordArea}>
                <input type="search" ref={el => (searchRef.current[0] = el)} 
                    onKeyDown={(e) => handleKeydown(e)} onChange={(e) => onChangeHandler(e)}/>
                <FontAwesomeIcon icon="fa-light fa-magnifying-glass" />
            </Element>
        </SubtitleArea>
    );
}